import React from "react";
import Styles from "../../styles.module.scss";
import Button from "../../../../components/button";
import Headline5 from "../../../../components/headings/Headline5";

function AlgorithmChallenge() {
  return (
    <div className={Styles.workSurvay}>
      <Headline5>Algorithm & Coding Challenge</Headline5>
      <p>
        Please go through the coding challenge to prove the talent inside you. This will attract more job openings and recruiters to your profile
      </p>
      <Button onClick={[]} variant="primary" size="medium">
      Take Test Now
      </Button>
      <div className={Styles.time}>40 mintues</div>
    </div>
  );
}
export default AlgorithmChallenge;
